import React, { Component } from 'react';
import Suggestions from '../Suggestions/Suggestions';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import { debounce } from 'lodash';
import Loader from 'react-loader-spinner';
import './MainSearchForm.scss';

class SearchForm extends Component {
  state = {
    query: '',
    showSuggestions: false,
  };

  componentDidMount() {
    this.searchInput.focus();
  }

  handleInputChange = debounce(evt => {
    evt.persist();
    this.setState(
      {
        query: this.searchInput.value,
      },
      () => {
        if (this.state.query.length > 1) {
          this.props.onMultiSearch(this.state.query);
          this.setState({ showSuggestions: true });
        } else {
          this.setState({ showSuggestions: false });
        }
      }
    );
  }, 1000);

  handleClickOutside = () => {
    this.resetInput();
  };

  resetInput = () => {
    this.setState(
      {
        query: '',
        showSuggestions: false,
      },
      () => {
        this.searchInput.value = '';
      }
    );
  };

  onSubmitHandler = evt => {
    evt.preventDefault();
  };

  escHandler = evt => {
    return evt.keyCode === 27 ? this.resetInput() : null;
  };

  render() {
    const { showSuggestions } = this.state;
    const { loadSuggestions, result } = this.props;

    let spinner = (
      <div className="loader-container">
        <Loader type="Watch" color="#00BFFF" height="24" width="24" />
      </div>
    );

    let suggestions;
    if (showSuggestions && loadSuggestions) {
      suggestions = <Suggestions results={result} />;
    } else if (showSuggestions && !loadSuggestions) {
      suggestions = spinner;
    }

    return (
      <div className="search-container-wrapper">
        <form className="search-container-form" onSubmit={this.onSubmitHandler}>
          <input
            autoComplete="off"
            ref={input => (this.searchInput = input)}
            className="search-container-search-input"
            type="text"
            name="search"
            onChange={evt => this.handleInputChange(evt)}
            onKeyDown={this.escHandler}
            placeholder="Simple typeahead search..."
          />
        </form>
        {suggestions}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  result: state.multiSearchReducer.result,
  loadSuggestions: state.multiSearchReducer.loadSuggestions,
});

const mapDispatchToProps = dispatch => ({
  onMultiSearch: query => dispatch(actions.multiSearch(query)),
});

SearchForm = onClickOutside(SearchForm);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchForm);
